module.exports = __webpack_public_path__ + "static/media/clutch_logo.31d5e55d.png";